module.exports = __webpack_public_path__ + "media/images/flavours/icon-animal_dark-f031f98b0da54bf80d39dacae707db22.png";